<template>
  <div>
    <div class="common-form" style="border-bottom: 1px solid #DCDFE6;">商户图表分析</div>
    <div>
      <el-col :span="8">
        <div class="cm-box">
          <div class="mt10" style="width:100%">
            <div class="Echarts" style="width:100%">
              <Echartone ref='waiterChartone'></Echartone>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="cm-box">
          <div class="mt10" style="width:100%">
            <div class="Echarts" style="width:100%">
              <Echarttwo style='' ref='waiterCharttwo' />
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="mt10" style="width:100%">
          <div class="Echarts" style="width:100%">
            <Echartthree style='' ref='waiterChartthree' />
          </div>
        </div>
      </el-col>
    </div>
  </div>
</template>
<script>
import StatisticsApi from "@/api/statistics.js";
import Echartone from "./SupAnalysis/echartone";
import Echarttwo from "./SupAnalysis/echarttwo";
import Echartthree from "./SupAnalysis/echartthree";

export default {
  components: {
    Echartone,
    Echarttwo,
    Echartthree
  },
  data() {
    return {};
  },
  mounted() {
    this.getData();
  },
  computed: {},
  methods: {
    getData() {
      self.loading = true;
      StatisticsApi.getsupThreeTable({}, true)
        .then(res => {
          self.loading = false;
          const { code, data } = res;
          if (code !== 1) return;
          const { first } = data.supplier;
          const { two } = data.supplier;
          const { three } = data.supplier;
          this.$nextTick(() => {
            // 数据
            const refone = this.$refs.waiterChartone;
            refone.initChart(first);
            // er数据
            const reftwo = this.$refs.waiterCharttwo;
            reftwo.initChart(three);
            // 三
            const refwaiterthree = this.$refs.waiterChartthree;
            refwaiterthree.initChart(two);
          });
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>
<style scoped>
.cm-box {
  padding: 10px;
  margin-bottom: 20px;
}
.grid-content {
  font-weight: 700;
  color: #000;
  font-size: 14px;
}
.pagecharts {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/supplier/part/SupAnalysis.vue